export function slugify(str) {
  return str
    .toString()
    .normalize('NFD')
    .replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .toLowerCase();
}
